import { useEffect, useRef, useState } from "react";
import {
    Box,
    Grid,
    Button,
    Checkbox,
    Popover,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    CircularProgress,
    Typography,
    TextField,
    IconButton,
    InputAdornment,
    Paper,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TablePagination,
    Tooltip,
    FormControl,
    TableSortLabel
} from "@mui/material";
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { useSelector, useDispatch } from "react-redux";
import ReportEmailPopup from "../ReportEmailPopup";
import Popup from "../../../../Base/views/Popup";
import { GetContractualWageReportAction, GetContractualWageReportNotProcessedAction } from "../../../../../../store/Finance/Reports/Action";
import { GenerateContractualWageReportHelper } from "../../../helper/Reports/GetWageReportHelper";
import { formatPayDatePeriod } from "../../../../Base/helper/baseFunctions";
import { AddMenuHeadingAction } from "../../../../../../store/Menu/Action";
import history from "../../../../../../history";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import { UpdatePayrollApproverStatusHelper } from "../../../helper/PayrollManagement/PayrollManagement";
import { GetPayrollTileViewAction } from "../../../../../../store/Finance/PayrollManagement/Action";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { GetCustomPayableEmployeeHelper } from "../../../helper/Employee/EmployeeTemplateHelper";
import { grey, red } from "@mui/material/colors";
import SelectableMultiSelect from "../../../../Base/views/SelectableMultiSelect";
import * as XLSX from "xlsx-js-style";

const ContractualPayroleReport = ({selectedYear, selectedMonth, currentMonthData, readOnly, userRole, paydate,worklocationData, handleWorkLoacation}) => {
    const dispatch = useDispatch();
    const { contractual_wage_report_data, isLoading } = useSelector(
        (state) => state?.FinanceReducer.WageReportsReducer
    );
    const { open, fixedMenu, isMobile } = useSelector(
        (state) => state?.MenuReducer
    );
    const date = new Date();
    const { work_hours_data } = useSelector(state => state.LeaveReducer?.WeekOffConfigureReducer);
    const [openPopup, setOpenPopup] = useState(false);
    const [payableFlag, setPayableFlag] = useState(false);
    const [payableDays, setPayableDays] = useState(0)
    const [payableDayError, setPayableDayError] = useState("")
    const [openwarningPopup, setWarningOpenPopup] = useState(false);
    const [navigateSection, setNavigateSection] = useState("");
    const [navigateId, setNavigateId] = useState("");
    const [msg, setMsg] = useState("");
    const [name, setName] = useState(date.toLocaleString('default', { month: 'short', year: 'numeric' }));
    const [anchorEl, setAnchorEl] = useState(null);
    const [, setAnchorE] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [openDialog2, setOpenDialog2] = useState(false);
    const [columns, setColumns] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [isLoadingbtn, setIsLoadingbtn] = useState(false);
    const [searchTerm, setSearchTerm] = useState(""); 
    const anchorRef = useRef(null);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('');

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };
    const [filters, setFilters] = useState({
        ats_work_location_id: []
    });
    const getTopLevelCategory = (key) => {
        if ([
            "adjusted_wage",
        ].includes(key)) return "Adjustments";

        if ([
            "total_deductions",
            ].includes(key)) return "Deductions";

        if ([
            "payroll_month_year",
            "payrun_date",
            "generated_by"
        ].includes(key)) return "Payroll Audit";
        if ([
            "employee_no",
            "employee_name",
            "prev_emp_id",
            "doj",
            "work_location",
            "office_email"
        ].includes(key)) return "Employee Info";

        if ([
            "days_in_month",
            "working_days_in_month",
            "weekly_off_days",
            "actual_working_days",
            "leaves_taken",
            "loss_of_pay",
            "days_to_be_paid",
            "festival_holidays",
            "optional_holidays"

        ].includes(key)) return "Attendance";

        if ([
            "fixed_wages",
            "gross_actual_salary_month",
            "gross_earned_salary_month",
            "total_salary_per_month",
            "net_salary",
        ].includes(key)) return "Salary Summary";

        if ([
            "pf_compliant",
            "pf_coverage",
            "payroll_setup_flag",
            "bonus_eligibility",
            "fifty_percent_rule"
        ].includes(key)) return "Compliance";

        if ([
            "overtime_hours",
            "overtime_rate",
        ].includes(key)) return "Overtime";

        return "Miscellaneous";
    };
    const flattenData = (data) => {
        const flatObject = {};
        const flatMeta = {};
        const excludedKeys = [
                "employees_state_insurance_corporation",
                "employer_contribution_to_pf",
                ];

        Object.keys(data).forEach((key) => {
            if (typeof data[key] === 'object' && data[key] !== null) {
                if (key === 'earned_salary_json' || key === 'actual_earnings_json') {
                    const prefix = key === 'earned_salary_json' ? 'earned_' : 'actual_';
                    Object.keys(data[key])?.forEach((nestedKey) => {
                        if (!excludedKeys.includes(nestedKey)) {  // remove ESIC and EPf from earned and actual
                        const finalKey = `${prefix}${nestedKey}`;
    
                         flatObject[finalKey] = data[key][nestedKey];
                         flatMeta[finalKey] = {
                            category: key === "actual_earnings_json" ? "Salary Structure" : "Earnings",
                            source: key,
                        };
                        }
                    });
                } else if (key === "employee_post_adjustment_component_earning_json" || key === "employee_post_adjustment_component_deduction_json") {
                    const components = data[key] || []; 
                    const isEarning = key === "employee_post_adjustment_component_earning_json";
                    const suffix = isEarning ? '_(Adjusted_earnings)' : '_(Adjusted_deductions)';
                    const category = isEarning ? "Adjustments" : "Deductions";
                    components?.forEach((component) => {
                        const finalKey = `${component?.label?.replace(/\s+/g, "_")}${suffix}`;
                        flatObject[finalKey] = component?.amount;
                        flatMeta[finalKey] = {
                            category: category,
                            source: key
                        };
                    });
                } else {
                    Object.keys(data[key]).forEach((nestedKey) => {
                        flatObject[nestedKey] = data[key][nestedKey];
                        flatMeta[nestedKey] = {
                            category: key === "deductions_json" ? "Deductions" : getTopLevelCategory(nestedKey),
                            source: key
                        };
                    });
                }
            } else {
                flatObject[key] = data[key];
                flatMeta[key] = {
                    category: getTopLevelCategory(key),
                    source: "root"
                };
            }
        });
        return { flatObject, flatMeta };
    };

    const getRelevantFields = (data) => {
        if (!data || data.length === 0) return [];
        const defaultFields = {
            employee_no: "Employee No",
            employee_name: "Employee Name",
            days_to_be_paid: "Paid Days",
            gross_earned_salary_month: "Total Earned Salary",
            total_deductions: "Total Deductions",
            net_salary: "Net Salary",
        };
        const flattenedData = data.map(item => flattenData(item));
        const allFields = new Set();
        flattenedData.forEach(record => {
            Object.keys(record?.flatObject).forEach(key => {
                if (!["pay_summary_pk", "employee_fk", "createdby", "createdon", "modifiedby", "modifiedon"].includes(key)) {
                    allFields.add(key);
                }
            });
        });
       const hasValidValues = (field) => {
            return flattenedData.some((record) => {
                const value = record.flatObject[field];;
                return (
                value !== null &&
                value !== undefined &&
                !(typeof value === "string" && value.trim() === "") &&
                Number(value) !== 0
                );
            });
        };
        const formatFieldName = (field) => {
            const prefixMatch = field.match(/^(actual_|earned_)/);
            const prefix = prefixMatch ? prefixMatch[0].replace('_', '').charAt(0).toUpperCase() + prefixMatch[0].slice(1).toLowerCase() : '';
            const formattedName = field.replace(/^(actual_|earned_)/, "").replace(/(json_)/gi, "");
            return `${prefix} ${formattedName}`
                .split(/[_\s]+/)
                .filter(word => word.trim() !== "")
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ')
                .trim();
        };
        const metaSample = {};

        flattenedData.forEach(record => {
            Object.entries(record.flatMeta || {}).forEach(([key, meta]) => {
                if (!metaSample[key]) {
                    metaSample[key] = meta;
                }
            });
        });
        return Array.from(allFields)
            .filter(field =>
                defaultFields[field] || hasValidValues(field)
            )
            .map(field => ({
                title: defaultFields[field] || formatFieldName(field),
                field: field,
                category: metaSample[field]?.category || "Miscellaneous",
                show: !!defaultFields[field],
                hidden: !defaultFields[field],
                export: true,
                cellStyle: { padding: "5px 0px 5px 2%",}
            }));
    };
    useEffect(() => {
        setTableData([])
        setColumns([])
        if (contractual_wage_report_data?.length > 0) {
            const dynamicColumns = getRelevantFields(contractual_wage_report_data);
            setColumns(dynamicColumns);
            const flattened = contractual_wage_report_data?.map(item => flattenData(item));
            setTableData(flattened.map(f => f.flatObject));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contractual_wage_report_data]);

    useEffect(() => {
        const numericMonth = parseInt(selectedMonth, 10); 
        const selectedDate = new Date(selectedYear, numericMonth - 1);
        setName(selectedDate.toLocaleString('default', { month: 'short', year: 'numeric' }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);
    useEffect(() => {
        const locationPayload = JSON.stringify((filters?.ats_work_location_id || [])?.map((item) => ({ ats_work_location_id: item?.work_location_id })));

        dispatch(GetContractualWageReportAction(
            { month: String(selectedMonth), 
              year: String(selectedYear),
              location: (filters?.ats_work_location_id || [])?.length > 0 ? locationPayload : null 
            }));
            // eslint-disable-next-line react-hooks/exhaustive-deps
    },[filters])
    const handleSendEmail = () => {
        setOpenPopup(true);
    };
    const handleGenerateClicked = () => { 
        if (!work_hours_data) {
            setMsg("Work Hour configuration is required for payroll settings. Please configure it now.");
            setNavigateSection("General");
            setNavigateId("4");
            setWarningOpenPopup(true);
        }  
        else {
            setIsLoadingbtn(true);
            const id = selectedRows?.map(item => item?.employee_fk);
            GetCustomPayableEmployeeHelper({
                employee_fk:  id?.length ? `{${id}}` : null,
            }).then((res) =>{ 
                if(res?.data?.statuscode === 200) {
                    setPayableDays(0)
                    setPayableFlag(res?.data?.data?.[0]?.payroll_custom_payable_contractual_employee)  
                    setAnchorE(null);
                    setOpenDialog(true);
                    setIsLoadingbtn(false);
                } else {
                    setIsLoadingbtn(false);
                    toast.error("Something went wrong")
                }
            })
        }
    };

    const handleNavigate = (menu, value) => {
        sessionStorage.setItem("selectedMenu", menu);
        dispatch(AddMenuHeadingAction({ heading: menu }));
        history.push({
            pathname: "/settings",
            state: { click_event: value },
        });
    };
    const handleGenerate = () => {
        if (payableDays === "" || payableDays === null ){
            setPayableDayError("Payable days is required.")
            return;
        } else if (!payableDays?.toString().match(/^\d{1,2}(\.\d{1,2})?$/)) {
            setPayableDayError("Invalid payable days.")
            return;
        } else {
            setPayableDayError("")
        }
        setIsLoadingbtn(true);
        const f_month = parseInt(selectedMonth, 10).toString();
        const id = selectedRows?.map(item => item.employee_fk);
        GenerateContractualWageReportHelper({
            employee_id: id?.length ? `{${id}}` : null,
            month: f_month,
            year: String(selectedYear),
            custom_payable_days: payableDays
        }).then((res) => {
            if (res?.data?.statuscode === 200) {
                dispatch(GetContractualWageReportAction({ month: f_month, year: String(selectedYear) }));
                dispatch(GetContractualWageReportNotProcessedAction({ month: f_month, year: String(selectedYear) }));
                dispatch(GetPayrollTileViewAction({ year: String(selectedYear) }))
                setSelectedRows([]);
            }
            else if (res?.data?.statuscode === 500) {
                toast.error(res?.data?.error?.[0]?.message)
            } else {
                toast.error("Something went wrong")
            }
            setIsLoadingbtn(false);
        });
        setOpenDialog(false);
    };
    const handleColumnToggle = (field) => {
        setColumns(prevColumns =>
            prevColumns.map(col =>
                col.field === field ? { ...col, show: !col.show, hidden: !col.hidden } : col
            )
        );
    };
    const handlePopoverOpen = (event) => {
        setAnchorEl(anchorRef?.current)
    };
    const handlePopoverClose = () => {
        setAnchorEl(null);
        setSearchTerm("");
    };
    const [exportLoading, setExportLoading] = useState(false);
    const formatValue = (value) => {
        if (typeof value === "boolean") return value ? "Yes" : "No";
        return value ?? "";
    };
    const CATEGORY_ORDER = [
        "Payroll Audit",
        "Employee Info",
        "Attendance",
        "Salary Structure",
        "Earnings",
        "Overtime",
        "Adjustments",
        "Deductions",
        "Compliance",
        "Salary Summary",
        "Miscellaneous"
    ];

    const buildGroupedSheet = (rows, orderedGrouped, paydate = null) => {
        const sheetData = [];

        if (paydate) {
            sheetData.push(["Pay Period", formatPayDatePeriod(paydate)]);
            sheetData.push([]);
        }

        const headerRow1 = [];
        const headerRow2 = [];

        Object.keys(orderedGrouped).forEach(category => {
            const cols = orderedGrouped[category];

            cols.forEach((col, idx) => {
                headerRow1.push(idx === 0 ? category : "");
                headerRow2.push(col.title);
            });
        });

        sheetData.push(headerRow1);
        sheetData.push(headerRow2);

        rows.forEach(row => {
            const { flatObject } = flattenData(row);

            const rowData = [];

            Object.values(orderedGrouped).forEach(cols => {
                cols.forEach(col => {
                    rowData.push(formatValue(flatObject[col.field]) || "");
                });
            });

            sheetData.push(rowData);
        });

        const ws = XLSX.utils.aoa_to_sheet(sheetData);

        // COLORS
        const CATEGORY_COLORS = {
            "Payroll Audit": "FFF2CC",
            "Employee Info": "D9E1F2",
            "Attendance": "E2EFDA",
            "Salary Structure": "FCE4D6",
            "Earnings": "E7E6E6",
            "Overtime": "FFF2CC",
            "Adjustments": "D9D2E9",
            "Deductions": "F8CBAD",
            "Compliance": "C6E0B4",
            "Salary Summary": "BDD7EE",
            "Miscellaneous": "EEEEEE"
        };

        let colIndex = 0;

        Object.keys(orderedGrouped).forEach(category => {
            const cols = orderedGrouped[category];
            const start = colIndex;
            const end = colIndex + cols.length - 1;

            ws["!merges"] = ws["!merges"] || [];
            ws["!merges"].push({
                s: { r: paydate ? 2 : 0, c: start },
                e: { r: paydate ? 2 : 0, c: end }
            });

            for (let c = start; c <= end; c++) {
                const cell = XLSX.utils.encode_cell({ r: paydate ? 2 : 0, c });

                if (!ws[cell]) continue;

                ws[cell].s = {
                    fill: { fgColor: { rgb: CATEGORY_COLORS[category] || "FFFFFF" } },
                    font: { bold: true }
                };
            }

            colIndex += cols.length;
        });

        return ws;
    };
    const handleExportAll = () => {
        setExportLoading(true);

        if (!columns || columns.length === 0) {
            console.error("Columns not ready for export");
            setExportLoading(false);
            return;
        }

        const rowsToExport = selectedRows?.length > 0 ? selectedRows : contractual_wage_report_data;

        // STEP 1: GROUP COLUMNS
        const grouped = {};
        columns.forEach(col => {
            const category = col.category || "Miscellaneous";

            if (!grouped[category]) grouped[category] = [];
            grouped[category].push(col);
        });

        // STEP 2: ORDER CATEGORY
        const orderedGrouped = {};
        CATEGORY_ORDER.forEach(cat => {
            if (grouped[cat]) {
                orderedGrouped[cat] = grouped[cat];
            }
        });

        // fallback if something missed
        Object.keys(grouped).forEach(cat => {
            if (!orderedGrouped[cat]) {
                orderedGrouped[cat] = grouped[cat];
            }
        });

        if (!orderedGrouped || Object.keys(orderedGrouped).length === 0) {
            console.error("No grouped columns found");
            setExportLoading(false);
            return;
        }

        const workbook = XLSX.utils.book_new();

        // MAIN SHEET
        const mainSheet = buildGroupedSheet(rowsToExport, orderedGrouped, paydate);
        XLSX.utils.book_append_sheet(workbook, mainSheet, "Pay Summary Report");

        // COMPLY / NON-COMPLY + LOCATION
        const groups = {};
        const complyRows = [];
        const nonComplyRows = [];

        rowsToExport.forEach(row => {
            const { flatObject } = flattenData(row);

            const location = flatObject?.work_location || "Not Specified";
            if (!groups[location]) groups[location] = [];
            groups[location].push(row);

            if (flatObject?.pf_compliant === true) {
                complyRows.push(row);
            } else {
                nonComplyRows.push(row);
            }
        });

        // COMPLY SHEET
        if (complyRows.length > 0) {
            const complySheet = buildGroupedSheet(complyRows, orderedGrouped);
            XLSX.utils.book_append_sheet(workbook, complySheet, "Comply");
        }

        // NON-COMPLY SHEET
        if (nonComplyRows.length > 0) {
            const nonComplySheet = buildGroupedSheet(nonComplyRows, orderedGrouped);
            XLSX.utils.book_append_sheet(workbook, nonComplySheet, "Non-Comply");
        }

        // LOCATION SHEETS
        Object.keys(groups).forEach(location => {
            let sheetName = location;

            if (sheetName.length > 31) sheetName = sheetName.substring(0, 31);
            if (sheetName.trim() === "") sheetName = "Unknown";

            const locationSheet = buildGroupedSheet(groups[location], orderedGrouped);
            XLSX.utils.book_append_sheet(workbook, locationSheet, sheetName);
        });

        // EXPORT
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = URL.createObjectURL(blob);
        const downloadLink = document.createElement("a");

        downloadLink.href = url;
        downloadLink.download = `${name}.xlsx`;
        downloadLink.setAttribute("target", "_blank");

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(url);

        setTimeout(() => {
            setExportLoading(false);
        }, 500);
    };
    const handleSearchChange = (event) => {
      setSearchTerm(event.target.value.toLowerCase()); 
    };
    const filteredColumns = columns
      ?.filter((col) => col.title.toLowerCase().includes(searchTerm)); 
    
    const [updateStatus, setUpdateStatus] = useState("")
    const handleStatusChange = (status) => {
        setUpdateStatus(status)
        setOpenDialog2(true);
    }
    const handleUpdateApproverStatus = () => {
        UpdatePayrollApproverStatusHelper({
            status: updateStatus,  // Approved/Rejected
            payroll_type: "regular", // regular / work-based
            month: String(selectedMonth),  
            year: String(selectedYear)
        }).then((res) => {
            dispatch(GetPayrollTileViewAction({ year: String(selectedYear) }))
            setOpenDialog2(false);
        })
    }
  
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const visibleColumns = columns?.filter((col) => col.show);

    const filteredData = tableData?.filter((row) =>
        visibleColumns?.some((col) =>
            row[col.field]?.toString().toLowerCase()?.includes(searchQuery.toLowerCase())
        )
    );

    const descendingComparator = (a, b, orderBy) => {
      let valA = a[orderBy];
      let valB = b[orderBy];
      
      if (!isNaN(valA) && !isNaN(valB) && valA !== "" && valB !== "" && valA !== null && valB !== null) {
        valA = Number(valA);
        valB = Number(valB);
      } else {
        valA = valA ? valA.toString().toLowerCase() : "";
        valB = valB ? valB.toString().toLowerCase() : "";
      }
      
      if (valB < valA) {
        return -1;
      }
      if (valB > valA) {
        return 1;
      }
      return 0;
    };

    const getComparator = (order, orderBy) => {
      return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
    };

    const sortedData = filteredData?.slice()?.sort(getComparator(order, orderBy));
    const handleChangePage = (_, newPage) => {
        setCurrentPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setCurrentPage(0);
    };

    const handleRowSelection = (row) => {
    if (selectedRows?.includes(row)) {
        setSelectedRows(selectedRows?.filter((r) => r !== row));
    } else {
        setSelectedRows([...selectedRows, row]);
    }
    };

    const handleSelectAll = (event) => {
    if (event.target.checked) {
        setSelectedRows(filteredData);
    } else {
        setSelectedRows([]);
    }
    };

    const handleFilterChange = (event, value) => {
        if (["ats_work_location_id"].includes(event)) {
        if (value) {
            setFilters({ ...filters, [event]: value });
        } else {
            setFilters({ ...filters, [event]: "" });
        }
      }
    }

    return (
        <Box sx={{overflowY: "auto" }}>
            <Paper sx={{ my: 1, p: 2, backgroundColor: "#f8fafc", borderRadius: 2 }}>
                <Grid container spacing={2}>
                <Grid item xs={6} md={2}>
                    <Typography variant="caption" color="text.secondary">Submitted On:</Typography>
                    <Typography variant="body2" fontWeight={500}>
                    {currentMonthData?.["Contractual_submittedon"] ? new Date(currentMonthData?.["Contractual_submittedon"]).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: true,
                    })
                    : "-"}
                    </Typography>
                </Grid>
                <Grid item xs={6} md={2}>
                    <Typography variant="caption" color="text.secondary">Submitted By:</Typography>
                    <Typography variant="body2" fontWeight={500}>
                        {currentMonthData?.["Contractual_submitted_by"] ? currentMonthData?.["Contractual_submitted_by"] : "-"}
                    </Typography>
                </Grid>
                <Grid item xs={6} md={2}>
                    <Typography variant="caption" color="text.secondary">Last Approved On:</Typography>
                    <Typography variant="body2" fontWeight={500}>
                        {currentMonthData?.["Contractual_approvedon"] ? new Date(currentMonthData?.["Contractual_approvedon"]).toLocaleString("en-IN", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: true,
                        })
                        : "-"}
                    </Typography>
                </Grid>
                <Grid item xs={6} md={2}>
                    <Typography variant="caption" color="text.secondary">Last Approved By:</Typography>
                    <Typography variant="body2" fontWeight={500}>
                        {currentMonthData?.["Contractual_approved_by"] ? currentMonthData?.["Contractual_approved_by"] : "-"}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                        <>
                            {false && <Box sx={{
                                display: "flex",
                                cursor: "pointer",
                                color: "#0854ffcf",
                                mr: 2,
                                fontSize: "16px",
                                fontWeight: 500,
                                "&:hover": {
                                    textDecoration: "underline",
                                }
                            }}>
                                <div onClick={() => history.push("/myemployee-reports", { activeTab: 1, month: selectedMonth, year: selectedYear })}>
                                    View Attendance Summary
                                </div>
                            </Box>}
                            {(contractual_wage_report_data?.length === 0 || selectedRows?.length > 0) && !readOnly && (
                                
                                <Button
                                onClick={handleGenerateClicked}
                                className="mpl-primary-btn"
                                disabled={isLoadingbtn}
                                startIcon={isLoadingbtn ? <CircularProgress size={18} color="inherit" /> : null}
                                >
                                {selectedRows?.length > 0 ? "Regenerate Payroll" : "Generate Payroll"}
                                </Button>
                            )}
                            {(userRole === "approver" || userRole === "both") && currentMonthData?.["Contractual_status"] === "Action Needed" && (
                                <>
                                <Button
                                    onClick={() => handleStatusChange("Approved")}
                                    className="mpl-primary-btn"
                                    color="success"
                                    sx={{ ml: 1 }}
                                >
                                    Approve
                                </Button>
                                <Button
                                    onClick={() => handleStatusChange("Rejected")}
                                    className="mpl-primary-btn"
                                    color="error"
                                    sx={{ ml: 1 }}
                                >
                                    Reject
                                </Button>
                                </>
                            )}
                        </>
                </Grid>
                </Grid>
            </Paper>
            <Box position="relative">
                <Box
                    ref={anchorRef}
                    sx={{ position: "absolute", top: 0, right: 0 }}
                />
                <Box
                    width={
                        isMobile ? "100%" : !fixedMenu && !open ? "calc(100vw - 75px)" : "calc(100vw - 270px)"
                    }
                sx={{
                    backgroundColor: "#ffffff",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    borderRadius: "8px",
                }}
                >
                {/* Header Section */}
                <Box
                    sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    backgroundColor: "#f3edfd",
                    padding: "15px",
                    }}
                >
                    {/* Title */}
                    { selectedRows?.length > 0 ?( <Box mr={2} sx={{
                            fontWeight: 600, color: "#f9c307"
                        }}>{`${selectedRows?.length} row(s) selected`}</Box>) : (
                        <Box>
                            <Typography variant="h6" fontWeight={600}>
                                Processed Employee
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Employees who have been processed for the selected period
                            </Typography>
                        </Box>
                        )}

                    {/* Action Buttons */}
                    <Box sx={{ display: "flex", alignItems: "center",flexDirection: {xs: "column", sm: "row"} , gap: "5px" }}>
                    <Box sx={{width: "180px", ml: "4px"}}>
                        <SelectableMultiSelect
                            multiple
                            label="Work Location"
                            placeholder="Select Location"
                            value={filters?.ats_work_location_id}
                            loading={handleWorkLoacation}
                            fieldLabel="work_location_name"
                            name="ats_work_location_id"
                            size="small"
                            onChangeEvent={handleFilterChange}
                            data={worklocationData}
                            menuHeight={150} // optional
                        />
                    </Box>
                    <TextField
                        placeholder="Search"
                        variant="standard"
                        fullWidth
                        size="small"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        InputProps={{
                        startAdornment: (
                            <SearchIcon sx={{ mr: 1, color: "action.active" }} />
                            ),
                            endAdornment: searchQuery && (
                            <ClearIcon
                                sx={{ ml: 1, cursor: "pointer", color: "action.active" }}
                                onClick={() => setSearchQuery("")}
                            />
                            ),
                        }}
                        sx={{
                        width: "250px",
                        "& .MuiOutlinedInput-root": { borderRadius: "8px" },
                        }}
                    />
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                    { contractual_wage_report_data?.length > 0 && <Tooltip title="Export as Excel">
                        <IconButton onClick={handleExportAll} disabled={exportLoading}>
                            {exportLoading ? <CircularProgress size={24} disableShrink sx={{ color: "#6d7c89" }}/> : 
                            <CloudDownloadIcon sx={{ color: "#6d7c89", fontSize: "24px" }} />}
                        </IconButton>
                    </Tooltip>}

                        { contractual_wage_report_data?.length > 0 &&  <Tooltip title="Send Email">
                        <IconButton onClick={handleSendEmail}>
                            <ForwardToInboxIcon sx={{ color: "#6d7c89", fontSize: "24px" }} />
                        </IconButton>
                        </Tooltip>}
                    {contractual_wage_report_data?.length > 0 &&  <Tooltip title="Manage Columns">
                        <IconButton onClick={handlePopoverOpen}>
                            <ViewColumnIcon sx={{ color: "#6d7c89", fontSize: "24px" }} />
                        </IconButton>
                        </Tooltip>}
                    </Box>
                    </Box>
                </Box>

                {/* Content Section */}
                {isLoading ? (
                    <Box
                    sx={{
                        height: 320,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#f3edfd",
                    }}
                    >
                    <CircularProgress />
                    </Box>
                ) : (
                    <>
                    {/* Table Section */}
                    <TableContainer
                        sx={{
                        minHeight: 320,
                        maxHeight: 320,
                        overflowY: "auto",
                        //   maxWidth: "100vw",
                        }}
                    >
                        <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                            {!readOnly && <TableCell padding="checkbox" style={{ backgroundColor: "#ffffff" }}>
                                <Checkbox
                                color="primary"
                                indeterminate={
                                    selectedRows?.length > 0 && selectedRows?.length < filteredData?.length
                                }
                                checked={
                                    filteredData?.length > 0 && selectedRows?.length === filteredData?.length
                                }
                                onChange={handleSelectAll}
                                />
                            </TableCell>}

                            {visibleColumns?.map((col) => (
                                <TableCell
                                key={col?.field}
                                style={{
                                    fontSize: "13px",
                                    fontWeight: "bold",
                                    padding: "5px 0px 5px 10px",
                                    textAlign: "start",
                                    backgroundColor: "#ffffff",
                                    cursor: "pointer",
                                }}
                                align="center"
                                onClick={() => handleRequestSort(col?.field)}
                                >
                                <TableSortLabel
                                    active={orderBy === col?.field}
                                    direction={orderBy === col?.field ? order : 'asc'}
                                >
                                    {col?.title}
                                </TableSortLabel>
                                </TableCell>
                            ))}
                            </TableRow>
                        </TableHead>
                        
                        <TableBody sx={{ backgroundColor: "#f3edfd"}}>
                            { contractual_wage_report_data?.length === 0 ? (
                                <Box
                                    sx={{
                                        height: 275,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "#888",
                                        fontSize: "16px",
                                        backgroundColor: "#f3edfd",
                                    }}
                                    >
                                    Pay summary report not generated for this month-year selection.
                                </Box>
                            ) : (
                                sortedData
                                ?.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage)
                                ?.map((row, index) => (
                                    <TableRow key={index}>
                                    {!readOnly && <TableCell padding="checkbox">
                                        <Checkbox
                                        color="primary"
                                        checked={selectedRows?.includes(row)}
                                        onChange={() => handleRowSelection(row)}
                                        />
                                    </TableCell>}
                                    {visibleColumns?.map((col) => (
                                        <TableCell
                                        key={col?.field}
                                        align="center"
                                        style={{
                                            padding: "10px 0px 10px 15px",
                                            textAlign: "start",
                                        }}
                                        >
                                        {/* {row[col?.field]} */}
                                        {/* {row[col?.field] || 0} */}
                                        {getCellValue(row, col?.field)}

                                        </TableCell>
                                    ))}
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                        <Box sx={{ minHeight: 275, backgroundColor: "#f3edfd" }}></Box>
                        </Table>
                    </TableContainer>

                    {/* Pagination Section */}
                    <TablePagination
                        rowsPerPageOptions={[25, 50]}
                        component="div"
                        count={filteredData?.length}
                        rowsPerPage={rowsPerPage}
                        page={currentPage}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        showFirstButton
                        showLastButton
                        sx={{ backgroundColor: "#ede4fc" }}
                        labelDisplayedRows={({ from, to, count, page }) =>
                            `Page ${page + 1} of ${Math?.ceil(count / rowsPerPage)} (${from}-${to} of ${count})`
                        }
                    />
                    </>
                )}
                </Box>
            </Box>

            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                 <Box sx={{  
                        width:"350px", maxHeight: "425px", overflowY: "auto"
                         }}>
                    {/* Search Field */}
                    <Box sx={{
                        padding:"12px 16px 0px 12px", 
                        position: "sticky", 
                        top: 0, 
                        backgroundColor: "white", 
                        zIndex: 1,
                        }}>
                        <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        placeholder="Type to search..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        sx={{
                            marginBottom: "8px",
                            backgroundColor: "white",
                            borderRadius: "4px",
                        }}
                        InputProps={{
                            endAdornment: searchTerm && (
                            <InputAdornment position="end">
                                <IconButton
                                onClick={() => setSearchTerm("")}
                                edge="end"
                                >
                                <CloseIcon />
                                </IconButton>
                            </InputAdornment>
                            ),
                        }}
                        />
                    </Box>
                    <Box
                        sx={{
                            minHeight: "87vh",
                            overflowY: "auto",
                            marginTop:"-10px"
                        }}
                        >
                        <List>
                        {filteredColumns?.length > 0 ? (
                            filteredColumns?.slice()?.sort((a, b) => a.title.localeCompare(b.title))?.map((col) => (
                                <ListItem
                                    key={col.field}
                                    onClick={() => handleColumnToggle(col.field)}
                                    sx={{height:"40px",cursor:"pointer"}}
                                >
                                    <ListItemIcon>
                                        <Checkbox checked={col.show} />
                                    </ListItemIcon>
                                    <ListItemText primary={col.title} />
                                </ListItem>
                            ))
                        ) : (
                            <Typography
                            sx={{
                                textAlign: "center",
                                marginTop: "25px",
                            }}
                            >
                            No results found
                            </Typography>
                        )}
                        </List>
                        </Box>
                </Box>
            </Popover>

            <Popup
                fullWidth={true}
                maxWidth="md"
                title="Pay Summary Report"
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
            >
                <ReportEmailPopup
                    setOpenPopup={setOpenPopup}
                    wage_report_data={selectedRows.length > 0 ? selectedRows : contractual_wage_report_data} employees_options={columns}
                    name={name}
                />
            </Popup>

            <Popup
                fullWidth={true}
                maxWidth="md"
                title="Warning"
                openPopup={openwarningPopup}
                setOpenPopup={setWarningOpenPopup}
            >
                <Typography sx={{ pt: 2, pb: 2, textAlign: "center" }} variant="h5">
                    ⚠️ {msg}
                </Typography>

                <Box display="flex" justifyContent="center" gap={2} sx={{ mt: 2 }}>
                    <Button
                        onClick={() => handleNavigate(navigateSection, navigateId)}
                        className="mpl-primary-btn"
                    >
                        Configure Now
                    </Button>
                </Box>
            </Popup>
                <Dialog open={openDialog2} onClose={() =>setOpenDialog2(false)} maxWidth="xs" fullWidth >
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        Confirm Action
                        <IconButton onClick={() =>setOpenDialog2(false)} size="small">
                        <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <Typography>
                        {`Are you sure you want to ${updateStatus === "Approved" ? "approve" : updateStatus === "Rejected" ? "reject" : ""}?`}
                        </Typography>
                    </DialogContent>
                    <DialogActions sx={{ px: 3, pb: 2 }}>
                        <Button onClick={handleUpdateApproverStatus} color={updateStatus === "Rejected" ? "error" : "primary"} variant="outlined">
                         {updateStatus === "Approved" ? "Approve" : updateStatus === "Rejected" ? "Reject" : ""}
                        </Button>
                    </DialogActions>
                </Dialog>
            {/* Generate payroll confirmation dialog */}
                <Dialog open={openDialog} maxWidth="xs" fullWidth >
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        Generate Payroll
                        <IconButton onClick={() =>setOpenDialog(false)} size="small">
                        <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography variant="body1" sx={{fontWeight: 600, color: "inherit"}}>
                                {`Payroll will be generated from ${formatPayDatePeriod(paydate)}. Are you sure you want to continue?`}
                                </Typography>
                            </Grid>
                           { payableFlag && ( <Grid key="payday" item xs={12}>
                            <Typography variant="body2" sx={{ mb: 1.5, color: "text.secondary" }}>
                                Some employees is configured with the Payable Days template. Please enter the number of payable days to calculate salary.
                            </Typography>
                            <FormControl fullWidth >
                                <TextField
                                    autoFocus
                                    size="small"
                                    value={payableDays}
                                    onChange={(e) => {setPayableDays(e.target.value); setPayableDayError("")}}
                                    variant="outlined"
                                    required
                                    label="Payable Days"
                                    name="custom_payable_days"
                                    type="number"
                                    placeholder="00.00"
                                    sx={{
                                        "& input::placeholder": {
                                        color: "#B0B0B0",
                                        },
                                    }}
                                        {...(payableDayError && {
                                        error: true,
                                        helperText: payableDayError,
                                        })}
                                    />
                            </FormControl>
                            </Grid>)}
                        </Grid>
                    </DialogContent>
                    <DialogActions sx={{ px: 3, pb: 2 }}>
                        <Box item xs={12} sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}>
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={() => setOpenDialog(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={handleGenerate}
                                 sx={{
                                    ":hover": { color: grey[50], background: red[700] },
                                    color: grey[50],
                                    background: red[500],
                                }}
                            >
                                Yes
                            </Button>
                    </Box>
                    </DialogActions>
                </Dialog>
        </Box>
    );
};
const getCellValue = (row, field) => {
  const nonNumericFields = ["work_location", "employee_name", "prev_emp_id", "employee_no", "office_email"];
  const value = row[field];
  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }
  if (nonNumericFields.includes(field)) {
    return value ? value : "-";
  }

  return value ? value : 0;
};

export default ContractualPayroleReport;